const APP_USER_AGENT_MARKER = "Treinoio-Profissional-App";

// Acesso pela WebView do app do profissional (treinoio-profissional/).
// O app injeta esse identificador no userAgent via prop
// `applicationNameForUserAgent`. Usar pra esconder itens que não fazem
// sentido in-app (ex: assinatura — política de IAP da Apple — e Sair,
// que vai pra tela nativa de Configurações).
export default function useIsAppWebView() {
	if (typeof navigator === "undefined" || !navigator.userAgent) return false;
	return navigator.userAgent.includes(APP_USER_AGENT_MARKER);
}
